export default function createAtMentionsViewState(pendingSocialActivityTags) {
    var viewState = {
        queryString: '',
        wordBeforeCursor: '',
        isSuggesting: false,
        isPopupShown: false,
        recipientsShown: [],
        selectedRecipientIndex: 0,
        isSearching: false,
        hasSearchedDirectory: false,
        atMentionTuples: {},
        mentionsAddedRecipients: [],
    };
    if (pendingSocialActivityTags && pendingSocialActivityTags.length > 0) {
        pendingSocialActivityTags.forEach(function (tag) {
            var parsedObj = JSON.parse(tag);
            if (parsedObj && parsedObj.a && parsedObj.b) {
                var parsedTagContents = JSON.parse(parsedObj.a);
                if (parsedTagContents) {
                    if (parsedObj.b == 'MentionAddedRecipients' &&
                        parsedTagContents instanceof Array) {
                        viewState.mentionsAddedRecipients = parsedTagContents;
                    }
                    else if (parsedTagContents.Mentioned) {
                        viewState.atMentionTuples[parsedObj.b] = {
                            EmailAddress: parsedTagContents.Mentioned,
                        };
                    }
                }
            }
        });
    }
    return viewState;
}
//# sourceMappingURL=createAtMentionsViewState.js.map